const UIContextMenu = require("./context-menu")
const UIModal = require("./modal")
const UIHeader = require("./header")
const UIMenu = require("./menu")
const UICardButton = require("./cardButton")
const UIToast = require("./toast")
const UIInvoicesPaid = require("./invoicesPaid")
const UIPrompt = require("./prompt")
const UIBanner = require("./banner")
const UIDescriptionInvoiceHeader = require("./descriptionInvoiceHeader/index")
const UIModernModal = require("./modernModal")
const UITypoIconlink = require("./iconlink")
const UIGeneralProductInformation = require("./generalProductInformation")
const UIReactDateRange = require("./react-dates-range")
const UIModernFloatLabel = require("./modernFloatLabel")

module.exports = {
  UIContextMenu,
  UIModal,
  UIHeader,
  UIMenu,
  UICardButton,
  UIToast,
  UIInvoicesPaid,
  UIPrompt,
  UIBanner,
  UIDescriptionInvoiceHeader,
  UIModernModal,
  UITypoIconlink,
  UIGeneralProductInformation,
  UIReactDateRange,
  UIModernFloatLabel
}



// WEBPACK FOOTER //
// ./src/shared/skin/icons/index.js